import { createIcon } from "@chakra-ui/react";

const BackIcon = createIcon({
  displayName: "BackIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4697 5.46973L11.5303 6.53039L6.06065 12.0001L11.5303 17.4697L10.4697 18.5304L3.93933 12.0001L10.4697 5.46973Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 12.7501H4.99999V11.2501H19V12.7501Z"
        fill="currentColor"
      />
    </>
  ),
});

export default BackIcon;
